import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BRAND } from '../../brand';

/// PrimeHat's logo: the P under a shop's awning, then "PrimeHat" (the owner's branding, primehat_branding/blue, 2026-10-23).
/// A picture, not a themed drawing: its blues are the brand's own. Drawn for the dark header, nav band, footer and panel bar
/// ("Prime" white); `ink` takes the version for white grounds ("Prime" in the panel's ink), as in the panel's phone drawer.
/// The files come from PrimeHat/tools/BrandImages; the width is the container's.
@Component({
    selector: 'app-brand-logo',
    template: `
        <picture>
            <source type="image/webp" [attr.srcset]="ink ? 'assets/images/logos/primehat-logo-ink.webp' : 'assets/images/logos/primehat-logo.webp'">
            <img class="brand-logo" [src]="ink ? 'assets/images/logos/primehat-logo-ink.png' : 'assets/images/logos/primehat-logo.png'"
                 width="547" height="160" [attr.alt]="brand.name" decoding="async">
        </picture>
    `,
    styles: [`
        :host { display: block; line-height: 0; }
        picture { display: block; }
        .brand-logo { display: block; width: 100%; height: auto; }
    `],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BrandLogoComponent {
    readonly brand = BRAND;

    /// The version for a white ground.
    @Input() ink = false;
}
